import getScrollOffset from './get-scroll-offset';
import scrollTo from './scroll-to';

const OFFSET = 120;

let currentLocation = null;
let hasScrolled = false;

function hashLinkHandler(location) {
  if (location) {
    currentLocation = location;
    hasScrolled = false;
  }

  const { hash } = currentLocation;

  if (hash && !hasScrolled) {
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);

      if (element) {
        const elementTop = element.getBoundingClientRect().top;
        scrollTo(Math.max(getScrollOffset() + elementTop - OFFSET, 0));
        hasScrolled = true;
      }
    });
  }
}

export default hashLinkHandler;

// onUpdate callback for react-router
export function onUpdate() {
  hashLinkHandler(this.state.location);
}



// WEBPACK FOOTER //
// ./app/services/hash-link-handler.js